/* LUMIXORA: Mengenauswahl auf der Produktseite – setzt die Menge im Kaufen-Formular */
(function () {
  function fmt(cents, f) {
    var v = Number(cents) / 100;
    function n(dec, th, d) {
      var s = v.toFixed(dec).split('.');
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return s.join(d);
    }
    return (f || '{{amount_with_comma_separator}} €').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount') return n(2, ',', '.');
      if (k === 'amount_no_decimals') return n(0, ',', '.');
      if (k === 'amount_no_decimals_with_comma_separator') return n(0, '.', ',');
      if (k === 'amount_with_apostrophe_separator') return n(2, "'", '.');
      return n(2, '.', ',');
    });
  }
  function qsFor(b) {
    var s = b.closest('.shopify-section') || document;
    return s.querySelector('product-form-component quantity-selector-component');
  }
  function mark(b, q) {
    b.dataset.sel = q;
    b.querySelectorAll('[data-qty]').forEach(function (o) {
      var on = Number(o.dataset.qty) === q;
      o.classList.toggle('is-active', on);
      o.setAttribute('aria-checked', on ? 'true' : 'false');
    });
  }
  function apply(b, q) {
    var qs = qsFor(b);
    if (!qs) return;
    var inp = qs.querySelector('input[name="quantity"]');
    if (inp && Number(inp.value) === q) return;
    try {
      if (typeof qs.setValue === 'function') qs.setValue(String(q)); else if (inp) inp.value = q;
      if (typeof qs.updateButtonStates === 'function') qs.updateButtonStates();
      if (typeof qs.onQuantityChange === 'function') qs.onQuantityChange();
      else if (inp) inp.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (e) { if (inp) { inp.value = q; inp.dispatchEvent(new Event('change', { bubbles: true })); } }
  }
  function prices(b, price, compare) {
    var f = b.dataset.moneyFormat;
    var set = function (sel, txt) { var el = b.querySelector(sel); if (el) el.textContent = txt; };
    set('[data-fl-p1]', fmt(price, f));
    set('[data-fl-c1]', compare && compare > price ? fmt(compare, f) : '');
    set('[data-fl-p2]', fmt(Math.round(price * 2 * 0.9), f));
    set('[data-fl-c2]', fmt(price * 2, f));
  }
  function init(b) {
    if (b.dataset.ready) return;
    b.dataset.ready = '1';
    if (!qsFor(b)) { b.hidden = true; return; }
    b.addEventListener('click', function (e) {
      var o = e.target.closest('[data-qty]');
      if (!o) return;
      var q = Number(o.dataset.qty);
      mark(b, q);
      apply(b, q);
    });
    var sec = b.closest('.shopify-section') || document;
    sec.addEventListener('variant:update', function (e) {
      var r = e.detail && e.detail.resource;
      if (!r) return;
      if (typeof r.price === 'number') prices(b, r.price, r.compare_at_price);
      var q = Number(b.dataset.sel || 1);
      setTimeout(function () { apply(b, q); }, 60);
    });
    document.addEventListener('quantity-selector:update', function (e) {
      var qs = qsFor(b);
      if (!qs || !(e.target === qs || qs.contains(e.target))) return;
      var q = Number(e.detail && e.detail.quantity);
      if (q) mark(b, q);
    });
  }
  function run() { document.querySelectorAll('[data-fl-bundle]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
